import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Manifesto from "./components/Manifesto";
import FollowUs from "./components/FollowUs";
import Tokenomics from "./components/Tokenomics";
import QrSection from "./components/QrSection";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      {/* Hero Section */}
      <div>
        <Box
          bg="linear-gradient(270deg, #FF914D 0%, #FDE63E 100%)"
          ps={{ base: "25px", xl: "146px" }}
          pe={{ base: "12px", xl: "120px" }}
        >
          <Header />
          <Hero />
        </Box>
        <Manifesto />
        <Box
          bg="linear-gradient(270deg, #FF914D 0%, #FDE63E 100%)"
          // ps="146px"
          // pe="120px"
        >
          <FollowUs />
        </Box>
        <Tokenomics />
        <Box
          bg="linear-gradient(270deg, #FF914D 0%, #FDE63E 100%)"
          // ps="146px"
          // pe="120px"
        >
          <QrSection />
        </Box>
        <Footer />
      </div>
    </>
  );
}

export default App;
